import React from "react";
import "./socials.scss";

function Socials() {
  return (
    <div className="social-menu">
      <li>
        <a
          href="https://drive.google.com/file/d/1lleEDwE9f2THsuE4LWzUcw3ltxrChNm6/view?usp=share_link"
          rel="noreferrer"
          target="_blank"
        >
          <i class="fa fa-file"></i>
        </a>
      </li>
      <li>
        <a href="https://github.com/Sharma572" target="__blank">
          <i className="fa fa-github"></i>
        </a>
      </li>
      <li>
        <a href="https://www.linkedin.com/in/raunak-sharma-" target="__blank">
          <i className="fa fa-linkedin"></i>
        </a>
      </li>
    </div>
  );
}

export default Socials;
